import axiosInstance from "../utils/axios";

export const getAllNotifications = async (query, callback) => {
    await axiosInstance.get(`/notification/getAll?${query}`)
        .then((res) => {
            callback(res?.data);
        })
        .catch((err) => {
            console.error("Error fetching notifications:", err);
        });
};
